import { Injectable } from '@angular/core';

export interface IRxntFormGroupControl {
  touched: boolean;
}

@Injectable()
export class RxntFormGroupService {
  reserveSpaceForError: boolean = false;
  isRequired: boolean = false;
  isRequiredMessage: string = 'Required.';

  private controls = new Set<IRxntFormGroupControl>();

  register(control: IRxntFormGroupControl): void {
    this.controls.add(control);
  }

  unregister(control: IRxntFormGroupControl): void {
    this.controls.delete(control);
  }

  validateAll(): void {
    this.controls.forEach(c => c.touched = true);
  }

  resetValidation(): void {
    this.controls.forEach(c => c.touched = false);
  }
}
